// extracted by mini-css-extract-plugin
export default {"menu":"wa","button":"xa","buttonIcon":"ya","list":"za","buttonActive":"Aa","listWrapper":"Ba"};